import { render, staticRenderFns } from "./BtnRounded.vue?vue&type=template&id=6acb992a"
import script from "./BtnRounded.vue?vue&type=script&lang=ts"
export * from "./BtnRounded.vue?vue&type=script&lang=ts"
import style0 from "./BtnRounded.vue?vue&type=style&index=0&id=6acb992a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports